import styled from "styled-components";

export const InfoTextContainer = styled.div<{ isMobile: boolean }>`
  background: var(--fd-colors-background-surface);
  line-height: 19px;
  padding: 0 var(--fd-space-space-4) var(--fd-space-space-4)
    var(--fd-space-space-4);
  ${({ isMobile }) =>
    !isMobile &&
    `
        border-radius: 0 0 var(--fd-radii-border-radius-020) var(--fd-radii-border-radius-020);
      `}

  & > * > * {
    padding-bottom: var(--fd-space-space-2);
  }

  & > * > *:first-child {
    padding-top: 0;
  }

  & > * > *:last-child {
    padding-bottom: 0;
  }
`;
